module.exports = __webpack_public_path__ + "img/dog-mobile-2.515fd97d.png";